{
  "search": "Search",
  "update": "Update",
  "tabs": {
    "users": "Users",
    "roles": "Roles",
    "roleProfiles": "Role Profiles",
    "organizations": "Organizations",
    "clientReportTemplates": "Client Report Templates",
    "featureFlags": "Feature Flags",
    "workflows": "Workflows",
    "downtimeSchedule": "Downtime Schedule",
    "pageConfigurations": "Page Configurations",
    "staticPageWidgetConfigurations": "Static Page Widget Configurations",
    "htmlTemplates": "Editable HTML Templates",
    "notificationGroups": "Notification Groups",
    "notificationDefinitions": "Notification Definitions",
    "customFields": "Custom Fields",
    "localizationSettings": "Localization Settings",
    "repCodes": "Rep Codes",
    "dashboards": "Dashboards",
    "documentManagement": "Document Management"
  },
  "userTable": {
    "name": "Name",
    "email": "Email",
    "role": "Role",
    "displayRole": "Display Role",
    "displayRoleFilterAll": "All display roles",
    "roleFilterAll": "All roles",
    "noResults": "No users match your filters",
    "accessType": "Access Type",
    "organization": "Organization",
    "status": {
      "header": "Last logged in at",
      "LOGGED_IN": "Logged in",
      "NOT_LOGGED_IN": "Not logged in",
      "INVITED": "Invited",
      "INVITATION_EXPIRED": "Invitation expired",
      "NOT_INVITED": "Not invited"
    },
    "inviteUsersButton": "Invite Users",
    "userSearch": "Search"
  },
  "userEntityTable": {
    "title": "Linked entities",
    "name": "Name",
    "relation": "Relation",
    "entityType": "Entity Type"
  },
  "userRepCodeEntityTable": {
    "title": "Linked entities (Rep codes)",
    "name": "Name",
    "repCodes": "Rep codes"
  },
  "roleTable": {
    "name": "Name",
    "navigationStyle": "Navigation Style",
    "noPermissions": "# of Permissions",
    "organization": "Organization"
  },
  "roleProfilesTable": {
    "name": "Name",
    "organization": "Organization",
    "inherited": "Inherited"
  },
  "organizationTable": {
    "name": "Name",
    "subdomain": "Subdomain",
    "parent": "Parent",
    "countriesJurisdictions": "Countries/Jurisdictions"
  },
  "workflowStates": {
    "DRAFT": "Draft",
    "ACTIVE": "Active",
    "ARCHIVED": "Archived"
  },
  "workflowTransitions": {
    "activate": "Set workflow as Active",
    "draft": "Set workflow as Draft",
    "archive": "Set workflow as Archived"
  },
  "workflowTransitionSuccess": "Workflow state changed",
  "workflowTable": {
    "name": "Name",
    "state": "State",
    "numberOfSteps": "# of Steps",
    "organization": "Organization"
  },
  "workflowModal": {
    "title": "Create new workflow",
    "name": "Name"
  },
  "userModal": {
    "editTitle": "Update user",
    "title": "Create new user",
    "firstName": "First Name",
    "lastName": "Last Name",
    "email": "Email (used for login)",
    "language": "Language",
    "phoneUsedForLogin": "Phone (used for login)",
    "phone": "Phone",
    "role": "Role",
    "avatar": "Avatar",
    "organization": "Organization",
    "accessType": "Access Type",
    "resetMfa": "Reset Multifactor Authentication",
    "autoInviteUser": "Auto invite user",
    "inviteUser": "Invite user",
    "resendInvitation": "Resend Invitation",
    "revokeInvitation": "Revoke Invitation",
    "repCodes": "Rep codes",
    "repCodesNone": "No rep codes",
    "viewFullClientGroup": "View full client group",
    "displayRole": "Display Role",
    "displayRoleNone": "None"
  },
  "accessUsers": {
    "title": "Access Users",
    "firstName": "First Name",
    "lastName": "Last Name",
    "email": "Email",
    "loginStatus": "Login Status",
    "lastLoginAt": "Last Login At",
    "organization": "Organization"
  },
  "userDeleteModal": {
    "deleteUser": "Delete user",
    "deletedCompletely": "User will be removed from OneHub completely. They will not be able to log in again.",
    "wantToProceed": "Do you want to proceed?",
    "yesDelete": "Yes, delete"
  },
  "userRevokeInvitationModal": {
    "title": "Revoke user invitation",
    "body": "The existing invitation will be revoked. You will be able invite the user again. Do you want to proceed?"
  },
  "userResetMultifactorModal": {
    "title": "Reset user multifactor",
    "body": "User will need to enroll in Multifactor Authentication on the next login. Do you want to proceed?"
  },
  "inviteSingleUserConfirmationModal": {
    "title": "Invite user",
    "body": "{{name}} will receive an invitation on this email ({{email}}). Do you want to proceed?"
  },
  "inviteUsersConfirmationModal": {
    "title": "Invite all pending users",
    "body": "A total of {{total}} user(s) will receive an invitation on their email. Do you want to proceed?"
  },
  "emailUpdateConfirmation": {
    "title": "Update user authentication",
    "body": "User will need to use the new email on the next login ({{email}}). Do you want to proceed?"
  },
  "roleModal": {
    "editTitle": "Update role",
    "title": "Create new role",
    "name": "Name",
    "description": "Description",
    "organization": "Organization",
    "roleProfile": "Role Profile",
    "permissions": "Permissions",
    "accessiblePages": "Pages",
    "dashboards": "Dashboards",
    "configurableTablePages": "Configurable Table Pages",
    "externalRoleId": "External Role ID",
    "defaultAccessType": "Default Access Type",
    "nonIndividualPageConfiguration": "Non-individual Page Configuration",
    "individualPageConfiguration": "Individual Page Configuration",
    "goalPageConfiguration": "Goal Page Configuration",
    "accountPageConfiguration": "Account Page Configuration",
    "accountGroupPageConfiguration": "Account Group Page Configuration",
    "householdPageConfiguration": "Household Page Configuration",
    "homePageConfiguration": "Home Page Configuration",
    "makeHouseholdDefaultView": "Make household default view",
    "subAccountPageConfiguration": "Sub Account Page Configuration",
    "individualTableStaticPageWidgetConfiguration": "Individual Table Static Page Widget Configuration",
    "nonIndividualTableStaticPageWidgetConfiguration": "Non-individual Table Static Page Widget Configuration",
    "householdTableStaticPageWidgetConfiguration": "Household Table Static Page Widget Configuration",
    "accountGroupTableStaticPageWidgetConfiguration": "Account Group Table Static Page Widget Configuration",
    "permissionsTable": {
      "read": "read",
      "write": "write",
      "transition": "transition"
    },
    "formTemplateWarning": "This should only be granted to internal users",
    "undefinedDefaultAuthenticationConnection": "Use the organization default"
  },
  "roleProfileModal": {
    "editTitle": "Update role profile",
    "title": "Create new role profile",
    "name": "Name",
    "description": "Description",
    "organization": "Organization",
    "permissions": "Default Permissions",
    "setAllPermitions": "Set all permissions",
    "accessiblePages": "Pages",
    "dashboards": "Dashboards",
    "configurableTablePages": "Configurable Table Pages",
    "permissionsTable": {
      "read": "read",
      "write": "write",
      "transition": "transition"
    }
  },
  "roleProfileConfirmationModal": {
    "title": "Are you sure you want to update the role profile?",
    "body": "You have made changes to a role profile. Do you want to confirm these changes?",
    "checkbox": "Update all related roles with these changes. This will override all changes made to {{roles}} role(s)."
  },
  "permissionLabels": {
    "account": "Accounts & Portfolios",
    "account_fee": "Account Management Fees",
    "account_number": "Custodian Account Numbers",
    "account_statement": "Account Statements",
    "account_statements": "Account Statement Generation",
    "adjustment_transaction": "Adjustment Transactions",
    "adjustment_transfer": "Adjustment Transfers",
    "advanced_organization_settings": "Advanced Organization Settings",
    "affiliate_conversion": "Affiliate User Conversion",
    "alert_banners": "Portal Alert Banners",
    "alert_report": "Suspicious Transaction Reports",
    "all_themes": "All Model Families (Not Only Suggested)",
    "api_exports": "CSV Data Exports",
    "api_token_jwt": "API Token JWT",
    "api_tokens": "API Tokens",
    "archived_bank_accounts": "Client Bank Accounts (Archived)",
    "asset_classes": "Asset Classes",
    "audit_logs": "Audit Logs",
    "bank_account": "Client Bank Accounts",
    "bank_account_disclosed": "Bank Transit & Account Numbers (Unmasked)",
    "beneficiary": "Account Beneficiaries",
    "beneficiary_pii": "Beneficiary PII",
    "billing_cycle": "Billing Cycles",
    "billing_fee": "Billed Fees",
    "billing_schedule": "Billing Schedules",
    "bulk_import": "Bulk Imports",
    "bulk_trade_request": "Bulk Trade Requests",
    "bulk_trade_run": "Bulk Trade Runs",
    "bulk_upsert_request": "Bulk Upsert Requests",
    "cash_and_holdings": "Cash & Holdings Statistics",
    "client": "Client Basic Information",
    "client_authentication": "Client Authentication Settings",
    "client_billing": "Client Billing Settings",
    "client_bulk_account_opening": "Client Bulk Account Opening",
    "client_group": "Client Groups",
    "client_high_risk_pii": "Client PII (High Risk)",
    "client_low_risk_pii": "Client PII (Low Risk)",
    "client_suitability": "Client Suitability",
    "client_taxid_disclosed": "Client Tax IDs (Unmasked)",
    "configurable_table_data": "Configurable Table Data",
    "configurable_table_page": "Configurable Table Pages",
    "configurable_table_page_export": "Configurable Table Page Exports",
    "corporate_account": "Corporate Accounts",
    "custodian_activity": "Custodian Activities",
    "custodian_connection": "Custodian Connections",
    "custodian_connection_config": "Custodian Connection Credentials",
    "custom_fields": "Custom Fields",
    "daily_fee": "Daily Fee Calculations",
    "dashboards": "Dashboards",
    "drift_settings": "Drift Settings",
    "event": "Client Events",
    "external_client_secrets": "Organization User External Client Secrets",
    "external_transfer": "External Transfers",
    "external_vendor_usage": "External Vendor Usage",
    "feature_flags": "Organization Feature Flags",
    "fee_setting": "Fee Settings",
    "fee_tier": "Fee Tiers",
    "files": "Client & Account Documents",
    "financial_product_org_history": "Financial Product Quantity & Value History",
    "financial_products": "Financial Products (Product Shelf)",
    "financial_products_snapshots": "Financial Product Price History",
    "flags": "Operational Flags",
    "force_account_open": "Force Account Opening",
    "foreign_exchange_rate": "FX Rates (Latest)",
    "foreign_exchange_snapshots": "FX Rates (Daily Snapshots)",
    "form_agreement": "Client Form Agreements",
    "form_completion": "Form Completions",
    "form_definition": "Form Definitions",
    "form_map_resolution": "Form Map Resolution",
    "form_template": "Form Templates",
    "fraud_risk": "Client Fraud Risk",
    "full_tax_disclosed": "Client Group Tax Numbers (Unmasked)",
    "goal": "Goals",
    "history": "History Snapshots",
    "id_verification": "ID Verification",
    "institution": "Financial Institutions",
    "integration_request_payload": "Integration Request Payloads",
    "integrations": "Integrations",
    "integrations_config": "Integrations (Full Configuration)",
    "invite_organization_users": "Invite Organization Users",
    "localizations": "Localization Settings",
    "manual_process": "Manual Processes",
    "manually_add_bank_account": "Client Bank Accounts (Manually Added)",
    "manually_upload_form_agreement": "Client Form Agreements (Manual Upload)",
    "model_change_proposals": "Model Change Proposals",
    "model_portfolios": "Model Portfolios",
    "news_and_insights": "News & Insights",
    "notes": "Notes",
    "notification": "Notifications",
    "notification_definition": "Notification Definitions",
    "notification_group": "Notification Groups",
    "organization_files": "Organization Documents",
    "organization_settings": "Organization Settings",
    "organization_user_authentication": "Organization User Authentication Settings",
    "organization_user_entities": "Organization User Entity Associations",
    "organization_user_profile": "Organization User Profile (Own)",
    "organization_users": "Organization Users",
    "organizations": "Organizations",
    "override_transfer_restrictions": "Override Transfer Restrictions",
    "page_configurations": "Page Configurations",
    "portfolio_optimizer": "Portfolio Optimizers",
    "portfolio_templates": "Portfolio Templates",
    "re_generate_pdf": "Regenerate Form Documents",
    "rebalance": "Rebalances",
    "recon_jobs": "Reconciliation Jobs",
    "reconcile_canceled_transfer": "Reconcile Canceled Transfers",
    "registered_adjustment_transfer": "Registered Account Adjustment Transfers",
    "rep_code": "Rep Codes",
    "reports": "Reports (Includes PII)",
    "retry_failed_webhooks": "Retry Failed Webhooks",
    "role_profiles": "Role Profiles",
    "roles": "Roles",
    "rule": "Suspicious Transaction Rules",
    "sales_tax_configuration": "Sales Tax Configuration",
    "schedules": "Trading Schedules",
    "siem_feed_jwt": "SIEM Feed JWT",
    "siem_feeds": "SIEM Feeds",
    "signer_type": "Signer Types",
    "sub_account_billing": "Sub-Account Billing",
    "sub_trade_request": "Sub-Trade Requests",
    "sub_trade_request_verification": "Sub-Trade Request Verification",
    "subAccount_liquidation": "Sub-Account Liquidation",
    "themes": "Model Families (Themes)",
    "trade": "Trades",
    "trade_request": "Trade Requests",
    "transaction": "Transactions",
    "transfer": "Transfers",
    "transfer_account_number_disclosed": "Transfer Account Numbers (Unmasked)",
    "transfer_obo_clients": "Transfers on Behalf of Clients",
    "upsert_bulk_trade_run_allocation_files": "Bulk Trade Run Allocation Files",
    "upsert_bulk_trade_run_bulk_trade_files": "Bulk Trade Run Trade Files",
    "webhook": "Webhooks",
    "withdraw_fees": "Withdrawal Fee Estimates",
    "workflow": "Workflows",
    "workflow_completion": "Workflow Completions"
  },
  "roleDeleteModal": {
    "deleteRole": "Delete role",
    "deletedCompletely": "Role will be removed from OneHub completely.",
    "wantToProceed": "Do you want to proceed?",
    "yesDelete": "Yes, delete role"
  },
  "roleProfileArchiveModal": {
    "archiveRoleProfile": "Archive role profile",
    "archiveConfirmation": "Role profile will be archived and will no longer be available on OneHub.",
    "wantToProceed": "Do you want to proceed?",
    "yesArchive": "Yes, archive role profile"
  },
  "newOrganizationModal": {
    "title": "Create new organization"
  },
  "a11y": {
    "moreActions": "More actions"
  },
  "dashboardsTable": {
    "name": "Name",
    "widgets": "Widgets",
    "state": "State",
    "organization": "Organization",
    "archive": "Archive",
    "modelName": "Dashboard"
  },
  "dashboardArchiveModal": {
    "title": "Archive dashboard?",
    "body": "This dashboard will be archived and will no longer appear in active dashboard lists.",
    "confirm": "Archive"
  },
  "successArchiveDashboard": "Dashboard archived successfully",
  "organizationDetails": {
    "saveChanges": "Save Changes",
    "basics": "Basics",
    "inheritance": "Inheritance",
    "name": "Name",
    "entityName": "Entity Name",
    "entityNameHelperText": "The name displayed on official documentation such as beneficiary designation forms",
    "subdomain": "Subdomain",
    "faviconLink": "Favicon Link",
    "browserTabTitle": "Browser Tab Title",
    "parent": "Parent",
    "useParentFormTemplates": "Use Parent Form Templates",
    "useParentProductShelf": "Use Parent Product Shelf",
    "useParentModelPortfolios": "Use Parent Model Portfolios",
    "useParentAssetClasses": "Use Parent Asset Classes",
    "useParentThemes": "Use Parent Themes",
    "useParentSchedules": "Use Parent Schedules",
    "useParentFeeTiers": "Use Parent Fee Grids",
    "useParentWorkflows": "Use Parent Workflows",
    "useParentRoleProfiles": "Use Parent Role Profiles",
    "useParentPageConfigurations": "Use Parent Page Configurations",
    "useParentStaticPageWidgetConfigurations": "Use Parent Static Page Widget Configurations",
    "useParentCustodianConnections": "Use Parent Custodian Connections",
    "useParentCustomFields": "Use Parent Custom Fields",
    "useParentBillingSchedules": "Use Parent Billing Schedules",
    "useParentIntegrations": "Use Parent Integrations",
    "useParentWebhooks": "Use Parent Webhooks",
    "useParentLocalizations": "Use Parent Localizations",
    "useParentThemeTokens": "Use Parent Theme Tokens",
    "useParentArticles": "Use Parent News and Insights Articles",
    "reviewTransactions": "Review Transactions",
    "allowInstantInvest": "Allow instant invest",
    "logo": "Logo URL",
    "topBarColor": "Top Bar Color",
    "topBarTextColor": "Top Bar Text Color",
    "primaryColor": "Primary Color",
    "pageBackgroundColor": "Page Background Color",
    "allowInactiveUserRebalancing": "Allow inactive user rebalancing",
    "allowInactiveUserFeeCalculation": "Allow inactive user fee calculation",
    "allowInactiveUserAdjustments": "Enable adjustments on frozen users",
    "allowLogout": "Allow Logout",
    "logoutRedirectUrl": "Logout Redirect Url",
    "customRedirectUrlHelperText": "Before updating this field, make sure it has been updated in auth0",
    "enableInactivityTimeOut": "Enable Inactivity Timeout",
    "inactivityTimeoutInMinutes": "Inactivity Timeout in Minutes",
    "allowPortfolioPerGoal": "Allow to set portfolio per goal",
    "requireManualAccountApproval": "Manual account approval",
    "requireSubTradeRequestApproval": "Trade verification required",
    "allowViewSubTradeRequestPairs": "Allow view sub-trade request pairs",
    "allowPendingTransactions": "Include pending transactions within holdings",
    "chargeAdminFeesToClient": "Charge admin fees to client",
    "uploadLogo": "Upload logo",
    "uploadErrorPageBackgroundImage": "Upload error page background",
    "displayNavbar": "Display navbar",
    "theme": "Theme",
    "accountTypeTaxRanking": "Account Type Tax Ranking",
    "supportUrl": "Support URL",
    "helpCentreUrl": "Help centre URL",
    "termsAndConditionsUrl": "Terms and conditions URL",
    "customUrl": "Custom URL",
    "customUrlHelperText": "Before updating this field, make sure the CNAME has been set by the CloudOps team",
    "urlError": "Invalid Url",
    "colorError": "Invalid hex code color",
    "logoUrlError": "Only PNG file is valid for the logo.",
    "requireFeeApproval": "Manual fee approval",
    "hideAutoUpdatePrices": "Hide auto update prices",
    "minimumInitialDeposit": "Minimum initial deposit",
    "minimumInitialDeposit1Dollar": "Minimum initial deposit is $1.00",
    "defaultTradingProcess": "Default trade process per sub-account",
    "bulkTradingProcess": "Default bulk trading process",
    "blockSuspiciousTransactions": "Block Suspicious Transactions",
    "cashOnHoldToTradeDays": "Hold time for trading",
    "cashOnHoldToWithdrawDays": "Hold time for withdrawal",
    "cancelTransferCutoffDays": "Days before a transfer when a transfer can no longer be cancelled",
    "holdTimeRange": "Hold time must be in 0-365 days range",
    "defaultSignUpRole": "Default sign-up role",
    "defaultAdvisorRole": "Default advisor role",
    "defaultClientRole": "Default client role",
    "authenticationTitle": "Authentication options",
    "disableStatsUpdateBasedOnTransactions": "Disable stats update based on transactions",
    "disableRebalanceReport": "Disable rebalance report calculation",
    "minRecurringDepositCents": "Minimum Scheduled Deposit (one-time, recurring)",
    "minRecurringDepositError": "Amount is less than the acceptable minimum recurring deposit.",
    "profileReviewTimeInMonths": "Profile Review Time in Months",
    "profileReviewTimeInMonthsError": "Profile Review Time in Months should be more than 0",
    "authenticationTheme": {
      "logo": "Logo URL (Authentication flow)",
      "primaryColor": "Primary color (Authentication flow)",
      "pageBackgroundColor": "Page background color (Authentication flow)"
    },
    "auth0DisplayName": "Display name (Authentication flow)",
    "enableMultiFactorAuthentication": "Enable Multi-Factor Authentication",
    "multiFactorAuthenticationTitle": "Multi-Factor Authentication Options",
    "multiFactorAuthenticationOptions": {
      "EMAIL": "Email",
      "SMS": "SMS",
      "AUTHENTICATOR": "Authenticator"
    },
    "enableRemeberBrowser": "Enable Remember Browser",
    "enableEmailFrenchTranslation": "Enable Email French Translation",
    "defaultAuthenticationConnectionTitle": "Authentication type",
    "defaultAuthenticationConnectionOptions": {
      "EMAIL_AND_PASSWORD": "Email and Password",
      "EMAIL_OTP": "Email - One-time code (Passwordless)",
      "ENTERPRISE": "Enterprise SSO"
    },
    "allowAccessToSubOrganizations": "Allow access to sub-organizations",
    "authenticationDomainsTable": "Authentication Domains",
    "authenticationDomain": {
      "url": "URL",
      "authenticationType": "Type",
      "enterpriseConnectionName": "Connection Name",
      "useHostedLogin": "Hosted Login",
      "editTitle": "Update Authentication Domain",
      "addTitle": "Add Authentication Domain",
      "removeDomain": "Remove Domain",
      "urlAlreadyExistsError": "URL already exists for this organization",
      "logoutUrl": "Logout URL"
    },
    "repCode": "Representative Code",
    "displayMenuBar": "Display menu bar when embedded",
    "displayCurrency": "Display currency",
    "allowPostOptimizationEditing": "Allow post-optimization editing of initiated sub-trade requests",
    "autoInviteImportedUsers": "Auto invite imported users",
    "localization": "Localization",
    "noLocalization": "none (defaults apply)",
    "country": "country",
    "currency": "currency",
    "enabledJurisdictions": "Enabled Jurisdictions",
    "jurisdictionsIn": "Jurisdictions in {{country}}",
    "jurisdictionsHelperText": "Pick one or more jurisdictions that this organization operates in",
    "allJurisdictions": "all",
    "selectedJurisdictions": "selected",
    "jurisdictionsDisabledMessage": "To select jurisdictions, first pick a localization (above) which defines country(ies)",
    "taxIdDetails": "Tax Identification Details",
    "clientType": "Client Type",
    "formatting": "Formatting",
    "notImplemented": "Not Implemented",
    "minAmountDeposit": "Minimum Amount Deposit",
    "minAmountDepositError": "Amount is less than the acceptable minimum amount deposit.",
    "errorPage": "Error page",
    "errorMessage": "Error message",
    "errorDescription": "Error description",
    "errorButtonText": "Button text",
    "productShelfCurrencies": "Product Shelf Supported Currencies",
    "enableContactSupport": "Enable Contact Support",
    "enableResourcesAndArticles": "Enable Resources and Articles",
    "enableFullCashTransfers": "Enable Full Cash Transfers",
    "enablePartialCashTransfers": "Enable Partial Cash Transfers",
    "enableAllInKindTransfers": "Enable All In-Kind Transfers",
    "baseCurrency": "Base Currency",
    "transferTitle": "Transfers"
  },
  "featureFlags": {
    "groups": {
      "ACCOUNT_TYPES": "Account Types",
      "ACCOUNT_TYPES_USA": "Account Types USA",
      "ACCOUNT_TYPES_UK": "Account Types UK",
      "TRADING": "Trading",
      "TRANSFERS": "Transfers",
      "ACCOUNT_MANAGEMENT": "Account Management",
      "PROFILE": "Profile",
      "DOCUMENTS_AND_STATEMENTS": "Documents and Statements",
      "TEMPORARY_FLAGS": "Temporary Flags"
    },
    "table": {
      "featureFlags": "Feature Flags",
      "status": "Status",
      "orgSettings": "Organization settings"
    },
    "status": {
      "enabled": "Enabled",
      "disabled": "Disabled"
    },
    "settings": {
      "on": "ON",
      "off": "OFF",
      "undefined": "INHERITED"
    },
    "saveButton": "Update",
    "updatedToastMessage": "Feature Flags have been updated.",
    "tooltip": {
      "status": "Overall status considering the inherited settings.",
      "orgSettings": "Settings defined for this organization.\nINHERITED - the closest parent organization with a specified value (ON or OFF) will define the feature flag status."
    }
  },
  "deleteLogoModal": {
    "title": "Delete Logo",
    "subtitle": "Are you sure you want to delete this logo from your dashboard",
    "yesDelete": "Yes, Delete",
    "cancel": "Cancel"
  },
  "deleteErrorPageImageModal": {
    "title": "Delete Background Image",
    "subtitle": "Are you sure you want to delete this image from your dashboard",
    "yesDelete": "Yes, Delete",
    "cancel": "Cancel"
  },
  "editableTemplate": {
    "title": "Editable HTML Templates",
    "templateName": "Template Name",
    "placeholder": "Enter template name here",
    "saveTemplate": "Save HTML Template"
  },
  "pageConfigurationTable": {
    "name": "Name",
    "type": "Type",
    "organization": "Organization"
  },
  "staticPageWidgetConfigurationTable": {
    "add": "Add",
    "name": "Name",
    "widgetType": "Widget Type",
    "organization": "Organization"
  },
  "customFieldTable": {
    "fieldLabel": "Field Label",
    "additionalInformation": "Additional Information",
    "inputFormat": "Input Format",
    "assiciateTo": "Object Associated To",
    "tranlatable": "Translatable",
    "organization": "Organization",
    "key": "Key"
  },
  "repCodeTable": {
    "code": "Code",
    "name": "Name",
    "organization": "Organization",
    "inherited": "Inherited",
    "assignedUsers": "Assigned Users",
    "designatedAdvisorContacts": "Designated Advisor Contacts",
    "noAssignedUsers": "No assigned users",
    "notDesignated": "Not designated"
  },
  "repCodeModal": {
    "title": "Create rep code",
    "editTitle": "Edit rep code",
    "archiveTitle": "Archive rep code?",
    "archiveBody": "Rep code will be removed completely. Do you want to proceed?",
    "code": "Code",
    "codeHelp": "Should consist of uppercase letters, numbers and underscores only",
    "name": "Name",
    "modelName": "rep code"
  },
  "pageConfigurationModal": {
    "title": "Create new page configuration",
    "name": "Name",
    "type": "Type",
    "types": {
      "INDIVIDUAL": "Individual",
      "NON_INDIVIDUAL": "Non-individual",
      "ACCOUNT": "Account",
      "GOAL": "Goal",
      "SUB_ACCOUNT": "Sub Account",
      "HOUSEHOLD": "Household",
      "ACCOUNT_GROUP": "Account Group"
    }
  },
  "staticPageWidgetConfigurationModal": {
    "title": "Create new static page widget configuration",
    "name": "Name",
    "type": "Type",
    "create": "Create",
    "types": {
      "INDIVIDUAL_TABLE": "Individual Table",
      "NON_INDIVIDUAL_TABLE": "Non-individual Table",
      "HOUSEHOLD_TABLE": "Household Table",
      "ACCOUNT_GROUP_TABLE": "Account Group Table"
    }
  },
  "editCustomFieldDialog": {
    "title": "Archive custom field?",
    "body": "Custom field will be removed completely. Do you want to proceed?"
  },
  "customFieldModal": {
    "title": "Create new custom field",
    "enableConditionalRules": "Add Conditional Rules",
    "editTitle": "Edit custom field",
    "keyHelp": "Should consist of lowercase letters, numbers and underscores only.",
    "nameHelp": "Characters not allowed: < > \\ | ^ * ` ~",
    "descriptionHelp": "Characters not allowed: < > \\ | ^ * ` ~",
    "selectOptionsHelp": "Characters not allowed: < > \\ | ^ * ` ~",
    "customFormatHelp": "Please reach out to OneVest integrations to set up a Custom formatted integration.",
    "keyPlaceholder": "boolean_field_10001",
    "key": "Key",
    "type": "Type",
    "format": "Format",
    "displayText": "Display text",
    "value": "Add section options (seperate each option with a line break)",
    "descriptionMsg": "The above text will apear in a modal window when the user clicks ",
    "formats": {
      "CHECKBOX": "Checkbox",
      "CURRENCY": "Currency",
      "DATE": "Date",
      "DATE_TIME": "Date time",
      "DROPDOWN_LIST": "Dropdown list",
      "EMAIL": "Email",
      "NUMBER": "Number",
      "PHONE": "Phone",
      "PHYSICAL_ADDRESS": "Physical address",
      "CUSTOM_AGREEMENTS": "Custom agreements",
      "BANK_ACCOUNT": "Bank account",
      "CUSTOM": "Custom",
      "RADIO_BUTTON": "Radio button",
      "SEARCH_LIST": "Search list",
      "SIMPLE_TEXT": "Simple text",
      "TEXT_AREA": "Text area",
      "TOGGLE_SWITCH": "Toggle switch"
    },
    "types": {
      "BOOLEAN": "Boolean",
      "CUSTOM_OBJECT": "Custom object",
      "DATE": "Date",
      "DECIMAL": "Decimal",
      "INTEGER": "Integer",
      "MULTIPLE_SELECT": "Multiple select",
      "SINGLE_SELECT": "Single select",
      "TEXT": "Text"
    },
    "objectType": "Object associated to",
    "objectTypes": {
      "ACCOUNT": "Account",
      "ENTITY": "Entity",
      "GOAL": "Goal",
      "HOUSEHOLD": "Household",
      "SUB_ACCOUNT": "Sub Account",
      "TRANSACTION": "Transaction",
      "HOLDING": "Holding",
      "ACCOUNT_GROUP": "Account Group"
    },
    "translatedDescription": "Additional Information",
    "translatedName": "Field label",
    "workflowStep": "Workflow step",
    "workflowOptions": {
      "APPROVAL": "Approval",
      "DOCUMENTS": "Documents",
      "EDIT_ACCOUNT": "Edit Account",
      "EDIT_GOAL": "Edit Goal",
      "EMPLOYMENT_INFORMATION": "Employment Information",
      "HOUSEHOLD": "Household",
      "NON_INDIVIDUAL_INFORMATION": "Non Individual Information",
      "PERSONAL_INFORMATION": "Personal Information",
      "PERSONS_OF_INTEREST": "Persons Of Interest",
      "RELATIONSHIP_INFORMATION": "Relationship Information",
      "RESIDENCY_INFORMATION": "Residency Information",
      "INCOME_ASSETS_AND_DEBTS": "Income Assets and Debts"
    },
    "customFieldSource": "Source",
    "source": {
      "CUSTODIAN": "Custodian",
      "INTERNAL": "Onevest"
    },
    "enablePositiveNegativeSign": "Enable positive/negative sign",
    "enableAggregation": "Enable aggregation"
  },
  "downtimeScheduleTable": {
    "add": "Add",
    "name": "Name",
    "state": "State",
    "status": "Status",
    "organization": "Organization"
  },
  "downtimeScheduleState": {
    "ACTIVE": "Active",
    "ARCHIVED": "Archived",
    "INACTIVE": "Inactive"
  },
  "downtimeScheduleStatus": {
    "UPCOMING": "Upcoming",
    "ONGOING": "Ongoing",
    "COMPLETED": "Completed"
  },
  "downtimeSchedulePlatform": {
    "ANDROID": "Android",
    "IOS": "IOS",
    "WEB": "Web"
  },
  "downtimeScheduleModal": {
    "title": "Manage Downtime Schedule",
    "name": "Name",
    "note": "Note",
    "platforms": "Platforms",
    "startTime": "Start Time",
    "endTime": "End Time",
    "excludeRoles": "Exclude Roles",
    "helpLink": "Help Link",
    "state": "State",
    "organization": "Organization",
    "downtimeScheduleDescription": "Description",
    "downtimeScheduleTitle": "Title",
    "create": "Create",
    "edit": "Update",
    "futureDateError": "Start Time must be in the future",
    "platformsRequired": "At least one platform must be selected"
  },
  "notificationDefinitionTable": {
    "name": "Name",
    "object": "Object",
    "notificationGroup": "Notification Group",
    "roleProfiles": "Role Profiles",
    "organization": "Organization",
    "event": "Event",
    "triggerObjectType": {
      "Account": "Account",
      "Goal": "Goal",
      "SubAccount": "SubAccount",
      "Transfer": "Transfer",
      "User": "User",
      "ScheduledTransfer": "Scheduled Transfer",
      "AccountStatement": "Account Statement"
    },
    "triggerEventType": {
      "RECONCILED": "Reconciled",
      "CREATED": "Created",
      "CHECK_ACCOUNT_MARKET_VALUE": "Check account market value",
      "AWAITING_REVIEW": "Awaiting review",
      "SIGNED": "Signed",
      "RESIGNED": "Resigned",
      "CANCELED": "Canceled",
      "COMPLETED": "Completed",
      "REQUESTED": "Requested",
      "REVIEWING": "Reviewing",
      "PROCESSING": "Processing",
      "INITIATED": "Initiated",
      "READY": "Ready",
      "FAILED": "Failed",
      "PERSONAL_ACCOUNT_INFORMATION_UPDATED": "Personal account information updated",
      "FROZEN": "Frozen",
      "PERSONAL_INFORMATION_UPDATED": "Personal information updated",
      "LOGIN_CREDENTIALS_UPDATED": "Login credentials updated",
      "USER_ID_CHECK_UPDATED": "User ID check updated",
      "SUITABILITY_SCORE_UPDATED": "Suitability score updated",
      "SUITABILITY_REVIEW_DUE_COMPLETE_11_MONTHS_AGO": "Suitability review coming due",
      "SUITABILITY_REVIEW_DUE_COMPLETE_13_MONTHS_AGO": "Suitability review due",
      "SUITABILITY_REVIEW_OVERDUE": "Suitability review overdue",
      "ACTIVE": "Active",
      "INACTIVE": "Inactive",
      "INVITATION_EMAIL_SENT": "Invitation Email sent",
      "SKIPPED": "Skipped"
    },
    "workflow": "Workflow",
    "add": "Add"
  },
  "notificationDefinitionModal": {
    "title": "Manage Notification Definition",
    "name": "Name",
    "notificationGroup": "Notification Group",
    "titleTemplate": "Title Template",
    "bodyTemplate": "Body Template",
    "linkTemplate": "Link Template",
    "linkText": "Link Text",
    "roleProfiles": "Role Profiles",
    "triggerObjectType": {
      "title": "Trigger Object",
      "Account": "Account",
      "Goal": "Goal",
      "SubAccount": "SubAccount",
      "Transfer": "Transfer",
      "User": "User",
      "ScheduledTransfer": "Scheduled Transfer",
      "AccountStatement": "Account Statement"
    },
    "triggerEventType": {
      "title": "Trigger Event",
      "RECONCILED": "Reconciled",
      "CREATED": "Created",
      "CHECK_ACCOUNT_MARKET_VALUE": "Check account market value",
      "AWAITING_REVIEW": "Awaiting review",
      "SIGNED": "Signed",
      "RESIGNED": "Resigned",
      "CANCELED": "Canceled",
      "COMPLETED": "Completed",
      "REQUESTED": "Requested",
      "REVIEWING": "Reviewing",
      "PROCESSING": "Processing",
      "INITIATED": "Initiated",
      "READY": "Ready",
      "FAILED": "Failed",
      "FROZEN": "Frozen",
      "PERSONAL_INFORMATION_UPDATED": "Personal information updated",
      "PERSONAL_ACCOUNT_INFORMATION_UPDATED": "Personal account information updated",
      "LOGIN_CREDENTIALS_UPDATED": "Login credentials updated",
      "USER_ID_CHECK_UPDATED": "User ID check updated",
      "SUITABILITY_SCORE_UPDATED": "Suitability score updated",
      "SUITABILITY_REVIEW_DUE_COMPLETE_11_MONTHS_AGO": "Suitability review coming due",
      "SUITABILITY_REVIEW_DUE_COMPLETE_13_MONTHS_AGO": "Suitability review due",
      "SUITABILITY_REVIEW_OVERDUE": "Suitability review overdue",
      "ACTIVE": "Active",
      "INACTIVE": "Inactive",
      "SKIPPED": "Skipped"
    },
    "create": "Create",
    "edit": "Update",
    "remove": "Remove"
  },
  "notificationGroupTable": {
    "name": "Name",
    "object": "Object",
    "notificationGroup": "Notification Group",
    "organization": "Organization"
  },
  "notificationGroupModal": {
    "title": "Create new notification group",
    "name": "Name",
    "description": "Description",
    "remove": "Remove"
  },
  "editNotificationGroupModal": {
    "title": "Edit notification group",
    "name": "Name"
  },
  "notificationChannelsOptions": {
    "enableTypes": {
      "EMAIL": "Enable email notifications",
      "IN_APP": "Enable in-app notifications",
      "PUSH": "Enable push notifications",
      "WEBHOOK": "Enable webhook notifications"
    },
    "setDefaultState": "Set default state",
    "allowEditByClient": "Allow editing by client"
  },
  "clientReportTemplates": {
    "new": "New Template",
    "frequency": "Frequency",
    "frequencies": {
      "WEEKLY": "Weekly",
      "MONTHLY": "Monthly",
      "QUARTERLY": "Quarterly",
      "YEARLY": "Annualy",
      "ONE_TIME": "One-time"
    },
    "association": "Association",
    "associations": {
      "USER": "User",
      "ACCOUNT": "Account",
      "ACCOUNT_GROUP": "Account Group",
      "GOAL": "Goal",
      "SUB_ACCOUNT": "Sub-account",
      "CLIENT_GROUP": "Client Group",
      "INDIVIDUAL": "Individual",
      "NON_INDIVIDUAL": "Non-individual"
    },
    "states": {
      "DRAFT": "Draft",
      "ACTIVE": "Active",
      "INACTIVE": "Inactive"
    },
    "lastGenerationDate": "Last Generation Date"
  },
  "localizationSettings": {
    "countries": "Countries",
    "defaultCurrency": "Base Currency",
    "languages": "Language(s)",
    "default": "default",
    "dateFormat": "Date Format",
    "deleteConfirmationModal": {
      "title": "Do you want to delete this localization?",
      "confirm": "Delete",
      "cancel": "Cancel"
    }
  },
  "documentManagement": {
    "name": "Name",
    "association": "Association",
    "lastUpdatedAt": "Last updated",
    "minVersion": "Version",
    "state": "State",
    "type": "Type",
    "view": "View",
    "edit": "Edit",
    "draft": "Draft",
    "activate": "Activate",
    "archive": "Archive",
    "editDraft": "Edit draft",
    "history": "History",
    "associatedTo": "Associated to",
    "searchByName": "Search by name",
    "ACCOUNT": "Account",
    "SUB_ACCOUNT": "Sub account",
    "SCHEDULE_TRANSFER": "Schedule transfer",
    "USER": "User",
    "GOAL": "Goal",
    "CLIENT_GROUP": "Client group",
    "NotAssigned": "NA",
    "minVersionLable": "Min version:",
    "template": "Document Template",
    "templateState": {
      "DRAFT": "Draft",
      "ACTIVE": "Active",
      "ARCHIVED": "Archived"
    },
    "noTitle": "No title defined",
    "action": {
      "edit": "Edit",
      "publish": "Publish",
      "preview": "Preview",
      "draft": "Save Draft",
      "download": "Download/Print",
      "apply": "Apply"
    },
    "toastMessage": {
      "success": "Form template has been successfully updated"
    },
    "objectType": {
      "ACCOUNT": "account",
      "SUB_ACCOUNT": "sub account",
      "SCHEDULE_TRANSFER": "schedule transfer",
      "USER": "user",
      "GOAL": "goal",
      "CLIENT_GROUP": "client group"
    },
    "previewObject": {
      "selectUser": "Clients",
      "selectGoal": "Goals",
      "selectAccount": "Accounts",
      "selectSubAccount": "SubAccounts",
      "selectScheduleTransfer": "Schedule Transfers",
      "selectClientGroup": "Client Groups",
      "selectTitle": "Select a {{objectType}} for preview"
    }
  },
  "localizationModal": {
    "createTitle": "Create New Localization",
    "editTitle": "Edit Localization",
    "name": "Name",
    "nameHelper": "Human-readable name of localization settings below",
    "countries": "Applicable Country(ies)",
    "countriesHelper": "One or more countries where an organization's clients are served",
    "defaultCurrency": "Base Currency",
    "defaultCurrencyHelper": "Default (Base) currency used in reporting",
    "languages": "UI Language(s)",
    "defaultLanguage": "Default Language",
    "dateFormat": "Date Format",
    "dateFormatHelper1": "Follow the ",
    "dateFormatHelper2": "dayjs formatting string",
    "datePreview": "Date Preview",
    "firstDay": "1st day of this month",
    "today": "today",
    "lastDay": "last day of this month",
    "phoneNumberCountryCodes": "Phone Number Country Codes",
    "phoneNumberCountryCodesHelper": "When country codes list is empty, applicable countries will be used as the default",
    "languageChangeWarning": "Changes to language settings will apply to all users."
  },
  "changeOrganization": "Change organization",
  "ORGANIZATION": "Organizational Access",
  "REP_CODE": "Rep Code Access",
  "ENTITY": "Entity Access",
  "exchangeRatesConfiguration": {
    "title": "Exchange Rates Configuration",
    "manualUpdate": "Manual Update",
    "autoUpdate": "Auto Update",
    "fromTo": "{{from}} to {{to}}",
    "rateError": "The rate should be higher than 0"
  },
  "bulkTradingProcessOptions": {
    "pair": "PAIR",
    "bucket": "BUCKET"
  },
  "configurableTablePages": {
    "archiveConfigurableTablePageModal": {
      "title": "Archive {{configurableTablePageName}}?",
      "bodyText": "This configurable table page will be archived. Do you want to proceed?"
    },
    "editor": {
      "preview": "Preview",
      "saveToSearch": "Save your changes to search and load preview data."
    },
    "title": "Configurable Table Pages",
    "inheritFromParent": "Inherit configurable table pages from parent organization",
    "description": "Configurable table pages allow you to create custom tables that can be used to display data from your organization. You can configure the filters, columns, and pagination to suit your needs.",
    "table": {
      "name": "Name",
      "sectionName": "Section Name",
      "organization": "Organization"
    },
    "noData": "No configurable table pages found",
    "errorLoading": "Error loading configurable table page",
    "createSuccess": "Configurable table page created successfully",
    "updateSuccess": "Configurable table page updated successfully",
    "requiredFiltersMessage": "Please set the required filters to view data: {{filtersNames}}",
    "noDataAvailable": "No records are available to display",
    "noSearchResults": "No results match the search criteria",
    "searchResultsWillAppearHere": "Search results will appear here",
    "errorLoadingData": "Error loading data",
    "total": "Total",
    "expandRow": "Expand row",
    "collapseRow": "Collapse row",
    "loading": "Loading...",
    "export": {
      "title": "Export Data",
      "download": "Download",
      "generating": "Generating export file...",
      "completed": "Export completed successfully",
      "failed": "Export failed"
    },
    "searchFilters": {
      "title": "SEARCH OPTIONS",
      "search": "Search",
      "reset": "Reset"
    },
    "modal": {
      "title": "Create Configurable Table Page",
      "editTitle": "Edit Configurable Table Page",
      "settings": {
        "title": "Settings",
        "name": "Name",
        "sectionName": "Section Name",
        "sectionIcon": "Section Icon",
        "navigateToPath": "Navigate To Path",
        "navigateToPathNone": "None",
        "navigateToPathKey": "Navigate To Path Key",
        "endpointUrl": "Endpoint URL",
        "paginationType": "Pagination Type",
        "enableDownload": "Enable Download",
        "useTopSearchPanel": "Use Top Search Panel",
        "navigateToPathError": "Navigate To Path is required when Navigate To Path Key is provided",
        "navigateToPathKeyError": "Navigate To Path Key is required when Navigate To Path is provided",
        "enableCustomPagination": "Customize pagination options",
        "customPageSizes": "Custom page size options (comma-separated)",
        "customPageSizesError": "Custom page size options are required when customize pagination options is enabled",
        "customPageSizesPlaceholder": "ex. 10, 25, 50, 100"
      },
      "filters": {
        "title": "Filters",
        "filterOptions": "Filter Options",
        "name": "Name",
        "key": "Key",
        "type": "Type",
        "format": "Format",
        "required": "Required",
        "isTopLevelFilter": "Is Top Level Filter",
        "additionalInfo": "Additional Info",
        "default": "Default",
        "types": {
          "TEXT": "Text",
          "SINGLE_SELECT": "Single Select",
          "MULTIPLE_SELECT": "Multiple Select",
          "DATE": "Date",
          "BOOLEAN": "Boolean",
          "INTEGER": "Integer",
          "DECIMAL": "Decimal"
        },
        "formats": {
          "TOGGLE_SWITCH": "Toggle Switch",
          "CHECKBOX": "Checkbox",
          "RADIO_BUTTON": "Radio Button",
          "DROPDOWN_LIST": "Dropdown List",
          "NUMBER": "Number",
          "CURRENCY": "Currency",
          "DATE": "Date",
          "DATE_TIME": "Date Time",
          "SIMPLE_TEXT": "Simple Text"
        },
        "options": {
          "title": "Options",
          "optionsType": "Options Type",
          "staticOptions": "Static Options",
          "optionsUrl": "Options URL",
          "dependsOn": {
            "title": "Depends On",
            "helpText": "Send other dropdown filters' values to the Options URL, and reload these options when they change. Make those filters required if the Options URL needs their values.",
            "usedAsParent": "Other filters depend on this filter, so it cannot depend on other filters.",
            "dependsOnFilter": "Depends On Filter",
            "passAs": "Pass As",
            "passAsHelpText": "Name of the value sent to the Options URL. Defaults to the filter key.",
            "passAsTaken": "This name is already used by another dependency.",
            "add": "Add Dependency"
          }
        },
        "staticOptionsKey": "Key",
        "staticOptionsLabel": "Label",
        "addStaticOption": "Add Static Option",
        "addFilter": "Add Filter",
        "updateFilter": "Update Filter"
      },
      "columns": {
        "title": "Columns",
        "columnOptions": "Column Options",
        "name": "Name",
        "key": "Key",
        "type": "Type",
        "formatter": "Formatter",
        "badgeColorKey": "Badge Color Key",
        "badgeMapping": {
          "title": "Badge Mapping",
          "value": "Value",
          "color": "Color",
          "addMapping": "Add Mapping"
        },
        "additionalInfo": "Additional Info",
        "sortable": "Sortable",
        "includeInTotals": "Include in totals",
        "types": {
          "DATE": "Date",
          "TEXT": "Text",
          "CURRENCY": "Currency",
          "NUMBER": "Number",
          "BADGE": "Badge",
          "PERCENTAGE": "Percentage"
        },
        "formatters": {
          "SIMPLE_TEXT": "Simple Text",
          "TRANSLATED_TEXT": "Translated Text",
          "CAPITALIZED_TEXT": "Capitalized Text",
          "DATE": "Date",
          "DATE_TIME": "Date Time",
          "MULTIPLY_BY_100": "Multiply by 100",
          "DIVIDE_BY_100": "Divide by 100"
        },
        "addColumn": "Add Column",
        "updateColumn": "Update Column",
        "rowScope": "Row scope",
        "rowScopes": {
          "MAIN": "Main",
          "COLLAPSIBLE": "Collapsible"
        }
      },
      "widgets": {
        "title": "Widgets",
        "addWidget": "Add Widget",
        "updateWidget": "Update Widget",
        "widgetType": "Widget Type",
        "options": "Options",
        "types": {
          "FREE_FORM_INPUT": "Free form HTML"
        }
      }
    },
    "paths": {
      "ACCOUNTS": "Accounts",
      "INDIVIDUALS": "Individuals",
      "NON_INDIVIDUALS": "Non-Individuals",
      "HOUSEHOLDS": "Households",
      "GOALS": "Goals",
      "SUB_ACCOUNTS": "Sub-Accounts",
      "ACCOUNT_GROUPS": "Account Groups"
    },
    "paginationType": {
      "OFFSET": "Offset",
      "CURSOR": "Cursor"
    }
  },
  "permissionTooltip": {
    "about": "About {{label}}",
    "actions": {
      "read": "Read:",
      "write": "Write:",
      "transition": "Transition:"
    }
  }
}
